import { useWatch } from 'react-hook-form';

import type { SchemaCreditRequestForm } from '../../schemas/creditRequestForm.schema';
import { getTotalFinancedAmount } from '../utils/getTotalFinancedAmount';

export const useRefinanceAmounts = (coApplicantHidden: boolean) => {
    const [
        dispositionsKredite,
        geschaeftsKredite,
        ratenKredite,
        kreditKarten,
        sonstigeVerbindlichkeiten,
        kreditBetrag,
        dataSnippets,
    ] = useWatch<
        SchemaCreditRequestForm,
        [
            'dispositionskredite',
            'geschaeftskredite',
            'ratenkredite',
            'kreditkarten',
            'sonstigeVerbindlichkeiten',
            'kreditBetrag',
            'dataSnippets',
        ]
    >({
        name: [
            'dispositionskredite',
            'geschaeftskredite',
            'ratenkredite',
            'kreditkarten',
            'sonstigeVerbindlichkeiten',
            'kreditBetrag',
            'dataSnippets',
        ],
    });

    const totalFinancedAmount = getTotalFinancedAmount({
        coApplicantHidden,
        dataSnippets,
        dispositionsKredite,
        geschaeftsKredite,
        kreditKarten,
        ratenKredite,
        sonstigeVerbindlichkeiten,
    });

    return {
        availableCredit: (kreditBetrag ?? 0) - totalFinancedAmount,
        kreditBetrag: kreditBetrag ?? 0,
        totalFinancedAmount,
    };
};
